import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, DestroyRef, Input, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { Router } from "@angular/router";
import { AuthenticationService } from "app/auth/authentication.service";
import { switchMap } from "rxjs";
import { DialogService } from "../dialog/dialog.service";
import { ResponsiveService } from "../responsive.service";

@Component({
    selector: "app-user-dropdown",
    templateUrl: "./user-dropdown.component.html",
    styleUrl: "./user-dropdown.component.scss",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
    ],
})
export class UserDropdownComponent {
    private destroyRef = inject(DestroyRef);
    private dialogService = inject(DialogService);
    private authenticationService = inject(AuthenticationService);
    private responsiveService = inject(ResponsiveService);
    private router = inject(Router);

    @Input() public accountIcon?: string | null;

    protected user$ = this.authenticationService.user$;
    protected isMobile$ = this.responsiveService.isMobile$;

    protected get accountIconOrDefault() {
        return this.accountIcon ?? "account_circle";
    }

    protected logout(event: MouseEvent) {
        event.preventDefault();

        this.dialogService
            .openConfirmation("Are you sure you would like to log out?")
            .pipe(
                switchMap(() => this.authenticationService.logout()),
                switchMap(() => this.router.navigateByUrl("/login")),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe();
    }
}
